import { ArrowsClockwiseIcon } from "@phosphor-icons/react/dist/csr/ArrowsClockwise";
import { DropdownMenuItem } from "@volca/ui/components/ui/dropdown-menu";
import { toast } from "@volca/ui/lib/toast";
import { useRebuildReport } from "@/profitability/report-query";
import type { ProfitabilityReport } from "@/profitability/types";
import { reportError } from "@/profitability/utils";

export const RebuildTemplateButton = ({
  businessId,
  report,
}: {
  businessId: string;
  report: ProfitabilityReport;
}) => {
  const rebuild = useRebuildReport(businessId);
  if (report.build_status === "building" || !report.sample_documents.length)
    return null;
  return (
    <DropdownMenuItem
      disabled={rebuild.isPending}
      aria-busy={rebuild.isPending}
      onClick={() =>
        rebuild.mutate(
          { reportId: report.id },
          {
            onError: (error) =>
              toast.error("The build could not start", {
                description: reportError(error),
              }),
          },
        )
      }
    >
      {<ArrowsClockwiseIcon />}
      Rebuild
    </DropdownMenuItem>
  );
};
